import * as Yup from 'yup';

import { FORM_VALIDATION_ERRORS } from 'src/consts';

const initialValues = {
  pharmacyName: '',
  pharmacyStreets: '',
  pharmacyPhone: '',
  pharmacyZipCode: null,
  pharmacyZipCodeLatitude: null,
  pharmacyZipCodeLongitude: null,
  isNewEntry: false,
};

export type InitialValues = typeof initialValues;

const validation = {
  initialValues,
  schema: Yup.object().shape({
    pharmacyName: Yup.string().required(FORM_VALIDATION_ERRORS.pharmacyName),
    // phone is required if user does not select from search results
    pharmacyPhone: Yup.string().when(['pharmacyStreets', 'isNewEntry'], {
      is: (pharmacyStreets, isNewEntry) => (!pharmacyStreets || pharmacyStreets.length === 0) && isNewEntry,
      then: Yup.string().required(FORM_VALIDATION_ERRORS.pharmacyPhone),
      otherwise: Yup.string().notRequired(),
    }),
  }),
};

export { validation };
